import { queryResponseValidator } from 'helpers/queryUtils';
import { z } from 'zod';

import api from './client';

export interface SympthomsChartData {
  documentId: string;
  documentType: string;
  createdAt: string;
  adhdWeight: string;
  anxietyWeight: string;
  depressionWeight: string;
  adhdTotal: string;
  anxietyTotal: string;
  depressionTotal: string;
  qualityOfLifeTotal: string;
}

const assignmentHistoryItemSchema = z.object({
  createdAt: z.string(),
  eventName: z.string().nullish(),
  assigneeId: z.string(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  assignedByUserId: z.string().nullish(),
  assignedByFirstName: z.string().nullish(),
  assignedByLastName: z.string().nullish(),
});
const getAssignmentHistoryResponseSchema = z.object({
  assignmentHistory: z.array(assignmentHistoryItemSchema),
});

export type AssignmentHistoryItem = z.infer<typeof assignmentHistoryItemSchema>;
type GetAssignmentHistoryResponse = z.infer<
  typeof getAssignmentHistoryResponseSchema
>;

export const getAssignmentHistory = async (
  userId: string,
  role: 'coach' | 'therapist'
) => {
  return api
    .get(`stats/assignment-history/${userId}/${role}`)
    .json()
    .then(
      queryResponseValidator<GetAssignmentHistoryResponse>(
        getAssignmentHistoryResponseSchema
      )
    );
};

export const getSympthomsStats = async (userId?: string) => {
  const response = await api
    .get(`stats/${userId}/sympthoms-chart`)
    .json<{ data: SympthomsChartData[] }>();

  return response.data;
};
